import React, { useMemo } from 'react';
import { Typography } from '@ui';
import { useReport } from './UsageReportContext';
import { minutesToHuman, intervals } from './utils';
import { ExportCSVButton } from './ExportCSVButton';
import { Table } from './Table';

export const LicenseUsageTable: React.FC = () => {
  const { table, timeSpan } = useReport();
  const label = intervals.find((i) => i.days === timeSpan)?.label.toLowerCase();
  const columns = useMemo(
    () => [
      { Header: 'Windows user', accessor: 'userName' as const },
      { Header: 'Host application', accessor: 'cad' as const },
      { Header: 'Machine name', accessor: 'machineName' as const },
      {
        Header: 'Usage',
        accessor: 'durationInMinutes' as const,
        Cell: (props: { value: number }) => minutesToHuman(props.value),
      },
    ],
    [],
  );

  return (
    <Table label='historical user activity' data={table} columns={columns}>
      <Typography variant='h5'>Users for the {label}</Typography>

      <ExportCSVButton />
    </Table>
  );
};
